export default __webpack_public_path__ + "static/media/132.29713654.gif";